import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import { Text, TextButton, TextButtonPriority, TextPriority, ThumbnailImage } from 'wix-ui-tpa/cssVars';
import { classes } from './file-preview.st.css';
import { Document, ExternalLinkSmall, SoundOn, Video } from '@wix/wix-ui-icons-common/on-stage';
import { resolveMediaType } from '../../../ui/file-upload/utils/resolve-media-type';
import { useTranslation } from '../../../contexts/translation-context';
import { fixUrl } from '../../../ui/file-upload/utils/fix-url';
const TextWithChildren = Text;
const Preview = props => {
  const size = 32;
  switch (props.mediaType) {
    case 'Image':
      return /*#__PURE__*/React.createElement(ThumbnailImage, {
        width: size,
        height: size,
        src: props.url,
        alt: props.displayName
      });
    case 'Audio':
      return /*#__PURE__*/React.createElement(SoundOn, {
        width: size
      });
    case 'Video':
      return /*#__PURE__*/React.createElement(Video, {
        width: size
      });
    case 'Document':
    default:
      return /*#__PURE__*/React.createElement(Document, {
        width: size
      });
  }
};
const FileItem = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.fileItem
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.filePreviewContainer
  }, props.filePreview), /*#__PURE__*/React.createElement(TextButton, _extends({
    as: "a",
    href: props.url
  }, props.url ? {
    target: '_blank'
  } : {}, {
    about: props.fileName,
    className: classes.downloadButton,
    priority: TextButtonPriority.secondary,
    suffixIcon: /*#__PURE__*/React.createElement(ExternalLinkSmall, null)
  }), props.fileName));
};
export const FormFilePreview = props => {
  const {
    t
  } = useTranslation();
  const value = useMemo(() => {
    if (!props.value) {
      return [];
    }
    return props.value.filter(file => file.url);
  }, [props.value]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, props.label, !value.length && /*#__PURE__*/React.createElement(TextWithChildren, {
    priority: TextPriority.secondary,
    className: classes.fileUploadPreviewEmpty
  }, t('field.quiz-file-upload.skipped')), value.map((file, index) => {
    const fileType = file.fileType;
    const url = fixUrl(file.url);
    return /*#__PURE__*/React.createElement(FileItem, {
      key: index,
      fileName: file.displayName,
      url: url,
      filePreview: /*#__PURE__*/React.createElement(Preview, {
        mediaType: resolveMediaType(fileType),
        displayName: file.displayName,
        url: file.url
      })
    });
  }));
};
//# sourceMappingURL=file-preview.js.map